import { Component } from '@angular/core'

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  standalone: false
})
export class TermsComponent {}
